import "./TalkWithUs.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import ConsultationForm from "./sections/ConsultationForm";
import StudioLocation from "./sections/StudioLocation";
import Footer from "@/reusable_sections/Footer";
export default function TalkWithUsPage() {
  return <div>
      <Header />
      <Contact />
      <ConsultationForm />
      <StudioLocation />
      <Footer />
    </div>;
}